import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetWaterbodiesQuery,
  usePublicGetWaterbodiesQuery,
  useGetWaterbodiesDefaultsQuery,
  usePublicGetWaterbodiesDefaultsQuery,
  useUpdateWaterbodiesMutation
} from '../features/modules/waterbodiesApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting waterbodies data based on the current route.
 */
export const useContextAwareGetWaterbodies = createContextAwareHook(
  useGetWaterbodiesQuery,
  usePublicGetWaterbodiesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting waterbodies defaults based on the current route.
 */
export const useContextAwareGetWaterbodiesDefaults = createContextAwareHook(
  useGetWaterbodiesDefaultsQuery,
  usePublicGetWaterbodiesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateWaterbodiesMutation
}; 